module.exports = __webpack_public_path__ + "static/PostGrotesk-Book-c11d0b7b86f07cac157d044d542f6566.woff";